import { render } from "./QuizGameComponent.vue?vue&type=template&id=1ffbf44e&scoped=true"
import script from "./QuizGameComponent.vue?vue&type=script&lang=js"
export * from "./QuizGameComponent.vue?vue&type=script&lang=js"

import "./QuizGameComponent.vue?vue&type=style&index=0&id=1ffbf44e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffbf44e"]])

export default __exports__